import React, { Component } from "react";

export class LNStats extends Component {
  static displayName = LNStats.name;

  constructor(props) {
    super(props);
    this.state = { stats: {}, initialized: false };
  }

  componentDidMount() {
    this.getLNData();
  }

  async getLNData() {
    const resp = await fetch("/stats/lnstats");
    const data = await resp.json();
    this.setState({ stats: data, initialized: true });
  }

  static renderTable(stats) {
    const commaFormat = new Intl.NumberFormat();

    return (
      <div>
        <table className="table table-striped" aria-labelledby="tabelLabel">
          <tbody>
            <tr>
              <th style={{ color: "green", fontWeight: "bold" }} title="The total number of lightning nodes with channels">
                Lightning Total Nodes:{" "}
              </th>
              <td>{commaFormat.format(stats.nodes)}</td>
            </tr>
            <tr>
              <th title="The number of channels connecting lightning nodes">Lightning Channels: </th>
              <td>{commaFormat.format(stats.channels)}</td>
            </tr>
            <tr>
              <th title="The cumulative bitcoin capacity across all channels">Network Capacity: </th>
              <td>{commaFormat.format(stats.capacity)} BTC</td>
            </tr>
          </tbody>
        </table>
        <div className="text-center" style={{ fontSize: 11 }}>
          (as of {stats.date})
        </div>
      </div>
    );
  }

  render() {
    let contents = this.state.initialized ? (
      LNStats.renderTable(this.state.stats)
    ) : (
      <p style={{ fontStyle: "italic" }}>
        <em>Loading...</em>
      </p>
    );

    return (
      <div className="mbox">
        <h4 className="text-center" title="The Lightning Network is a Layer 2 payment protocol that operates on top of Bitcoin. It enables fast transactions among participating lightning nodes and has been touted as a solution to the Bitcoin scalability problem.">
          <i className="bi bi-lightning-charge-fill" style={{ color: "blue" }}></i>
          <span className="m-2"> Lightning Network</span>
        </h4>
        <hr />
        {contents}
        <br />
        <br />
        <br />
        <div style={{ fontSize: 11 }} className="mt-4">
          <span className="p-2">source: bitcoin visuals</span>
        </div>
      </div>
    );
  }
}
